module.exports = __webpack_public_path__ + "static/media/Slide02.e5d7297e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide02.png
// module id = 1624
// module chunks = 0